var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 52,
    viewBox: "0 -15 109 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.322 1H19.6198L17.2996 1.96801V4.59133L19.2994 6.14983C19.4903 6.32653 19.6423 6.54078 19.7459 6.77904C19.8495 7.0173 19.9024 7.2744 19.9013 7.53409L24.7552 22.5577C24.8329 23.9516 25.5901 25.0551 26.4929 25.0551H82.6042C83.507 25.0551 84.2642 23.9516 84.3321 22.5577L89.1861 7.54377C89.1884 7.28694 89.2419 7.03313 89.3436 6.79714C89.4453 6.56115 89.593 6.34769 89.7782 6.16919L91.7198 4.59133V1.96801L89.322 1Z",
    fill: "#2E85EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0692 4.87207H19.1321L17.5617 6.71816V9.65959L19.5656 11.6411C19.7549 11.8613 19.9065 12.1292 20.0109 12.4278C20.1154 12.7264 20.1704 13.0493 20.1726 13.3764L18.0723 26.9144C18.1494 28.6497 18.9009 30.0404 19.8065 30.0404H88.5857C89.4914 30.0404 90.2428 28.6497 90.3103 26.9144L88.8266 13.3764C88.8263 13.0511 88.8784 12.7293 88.9794 12.4308C89.0805 12.1323 89.2285 11.8635 89.4143 11.6411L91.3411 9.65959V6.71816L85.0692 4.87207Z",
    fill: "#0F3251"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4288 29.0723H19.5033V34.8803H88.4288V29.0723Z",
    fill: "#143C6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9011 7.7373L16.9307 15.5879L20.9109 30.2727L22.2506 32.17L23.8722 29.0723L21.9011 7.7373Z",
    fill: "#164E93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7397 7.7373L91.7198 15.5879L87.7299 30.2727L86.3902 32.17L84.5457 28.5883L86.7397 7.7373Z",
    fill: "#164E93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8656 13.8262C89.8656 13.8262 91.4771 15.2298 91.448 15.7622L87.1377 29.1402C87.0795 30.3792 86.3999 31.3666 85.5942 31.3666H22.8234C22.0176 31.3666 21.3381 30.3986 21.2701 29.1402L16.9501 15.7525C16.9501 15.2201 18.4743 13.8165 18.4743 13.8165L18.3966 11.9482H3V19.1406L5.78615 21.3283C6.0534 21.5748 6.2658 21.8745 6.40961 22.208C6.55342 22.5415 6.62544 22.9013 6.62102 23.2643L13.4165 43.5345C13.5136 45.4705 14.5717 47.0194 15.824 47.0194H93.2828C94.5448 47.0194 95.5835 45.4802 95.6903 43.5345L102.428 23.2643C102.426 22.9026 102.498 22.5444 102.64 22.2116C102.782 21.8787 102.99 21.5782 103.253 21.3283L105.99 19.1309V11.9579H90.0403L89.8656 13.8262Z",
    fill: "#2E85EF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M89.322 1H19.6198C19.5227 1.05808 17.2996 1.96801 17.2996 1.96801H91.6907C91.6907 1.96801 89.3996 1.11616 89.322 1Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M27.1725 5.30753H81.8469C81.9312 5.24281 82.0223 5.18762 82.1188 5.14297L83.6623 4.52344H25.328L26.9007 5.13329C27.0062 5.16415 27.1005 5.22464 27.1725 5.30753V5.30753Z",
    fill: "#0B1C30"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M3.06793 19.2568L5.82495 21.4348C6.08727 21.6841 6.2951 21.9848 6.43542 22.3179C6.57575 22.6511 6.64553 23.0096 6.64041 23.3709L13.3873 43.5927C13.4844 45.5287 14.5329 46.9904 15.7852 46.9904H20.3382L18.3966 46.1095C16.2317 45.0156 14.727 41.9567 14.6202 38.4332L10.4944 13.8359H3.06793V19.2568Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M95.7097 43.593L102.428 23.3615C102.432 23.0071 102.508 22.6571 102.652 22.3328C102.795 22.0084 103.003 21.7163 103.262 21.4739L106 19.2959V13.875H98.6221L94.4865 38.4335C94.37 41.9571 92.8653 44.9482 90.7005 46.0421L88.7589 46.952H93.2828C94.5642 46.952 95.6029 45.529 95.7097 43.593Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.367 8.55078H14.397L3.06793 11.9582H18.4063L23.367 8.55078Z",
    fill: "#589EF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0699 8.55078H94.671L106.01 11.9582H90.0404L85.0699 8.55078Z",
    fill: "#589EF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.367 8.55078L18.3966 11.9582L18.4646 13.8361L23.435 10.1286L23.367 8.55078Z",
    fill: "#1B5FB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7649 4.3877L23.367 5.37507V8.24039L23.435 10.1183L24.697 9.1116L24.7649 4.3877Z",
    fill: "#1B5FB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6623 4.3877L85.0699 5.37507L85.0602 8.24039L84.9923 10.1183L83.74 9.1116L83.6623 4.3877Z",
    fill: "#1B5FB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0699 8.55078L90.0403 11.9582L89.9724 13.8361L85.002 10.1286L85.0699 8.55078Z",
    fill: "#1B5FB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.671 5.375H85.0699V8.55008H94.671V5.375Z",
    fill: "#2E85EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.367 5.375H14.4067V8.55008H23.367V5.375Z",
    fill: "#2E85EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6623 4.3877H91.4577L94.671 5.37507H85.0699L83.6623 4.3877Z",
    fill: "#589EF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7649 4.3877H17.6103L14.397 5.37507H23.367L24.7649 4.3877Z",
    fill: "#589EF4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M18.0568 19.1699H3L5.78615 21.3286C6.00493 21.471 6.17442 21.6772 6.27154 21.9191H18.9402L18.0568 19.1699Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M90.3704 19.1699L89.487 21.9191H102.806C102.939 21.7113 103.095 21.5196 103.272 21.348L106.01 19.1699H90.3704Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M16.9501 15.7519C16.9456 15.7328 16.9456 15.7129 16.9501 15.6938C17.0851 15.2374 17.3643 14.8368 17.7462 14.5515L18.4645 13.8643H3.06793V17.0684H17.3773L16.9501 15.7519Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M89.9044 13.8359L90.6228 14.5232C91.0002 14.823 91.275 15.2323 91.4091 15.6945C91.4046 15.7136 91.4046 15.7335 91.4091 15.7526L90.982 17.0691H106V13.8359H89.9044Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9728 31.3662H22.8234V32.1697H85.9728V31.3662Z",
    fill: "#589EF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4156 32.1703C22.2118 31.8411 22.0079 31.4927 21.804 31.1442C19.2568 26.6917 17.6078 21.7853 16.9501 16.7014V15.7334L21.2507 29.1307L22.4156 32.1703Z",
    fill: "#589EF4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M87.8755 35.4321H20.9109L22.8234 32.1699H85.9631L87.8755 35.4321Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9631 32.1703C86.1766 31.8411 86.3805 31.4927 86.5844 31.1442C89.128 26.6901 90.7767 21.7844 91.4383 16.7014C91.4383 16.382 91.4383 16.0625 91.4383 15.7334L87.1377 29.1404L85.9631 32.1703Z",
    fill: "#589EF4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 109,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 54.3932,
    y1: 35.4321,
    x2: 54.3932,
    y2: 32.1699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 103,
    height: 46,
    fill: "white",
    transform: "translate(3 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/Trash.d2cf8ab5485004471026afc20f064b40.svg";
export { ForwardRef as ReactComponent };